/*eslint-disable*/
import { InputLabel, OutlinedInput, Typography } from '@material-ui/core';
import { Box } from '@mui/system';
import PropTypes from 'prop-types';
import styles from './CustomTextArea.module.css';

export const CustomTextArea = ({
  id,
  dataTestId,
  inputLabelAriaLabel,
  inputLabelClassName,
  label,
  autoFocus,
  InputClassName,
  handleChange,
  placeholder,
  fullWidth,
  handleBlur,
  inputProps,
  value,
  multiLine,
  noColon,
  rows,
  dataTestIdForLabel,
  endAdornment,
  disabled,
  error,
  maxLength,
  isStar,
  required,
  flow,
}) => {
  return (
    <>
      <InputLabel
        sx={{
          whiteSpace: 'break-spaces',
        }}
        htmlFor={id}
        data-testid={dataTestIdForLabel}
        aria-label={inputLabelAriaLabel}
        className={`${styles.label_title} ${inputLabelClassName || ''}`}
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        {/* <Box component="div" sx={{ width: '75%' }}>
          {label || ''} <span>*</span>:
        </Box> */}
        <Box component="div" textAlign="left" sx={{ width: '80%' }}>
          {label || ''}
          {required && <span className="asterisk"> *</span>}
          {noColon ? '' : <Typography sx={{ display: 'inline-block' }}>:</Typography>}
        </Box>
        <Box component="div" className={styles.char_count}>
          {value?.length} of {maxLength}
        </Box>
      </InputLabel>
      <OutlinedInput
        data-testid={dataTestId || null}
        id={id}
        multiline={multiLine}
        rows={rows}
        name={id}
        autoFocus={autoFocus || false}
        className={`${styles.outlined_inputs} ${error ? styles.outlined_inputs_error : ''} ${
          InputClassName || ''
        }`}
        onChange={handleChange}
        placeholder={placeholder}
        fullWidth={fullWidth || false}
        onBlur={handleBlur}
        inputProps={{ ...inputProps, 'aria-required': required || false }}
        value={value || ''}
        autoComplete="off"
        endAdornment={endAdornment || null}
        disabled={!!disabled}
        style={flow === 'rvm' ? { minHeight: 0 } : {}}
      />
      {error ? (
        <Box className={`${styles.errorMsg}`} role="alert">
          {error}
        </Box>
      ) : (
        ''
      )}
    </>
  );
};

CustomTextArea.propTypes = {
  id: PropTypes.string,
  rows: PropTypes.number,
  maxLength: PropTypes.number,
  required: PropTypes.bool,
  inputLabelAriaLabel: PropTypes.string,
  inputLabelClassName: PropTypes.string,
  label: PropTypes.string,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  InputClassName: PropTypes.string,
  handleChange: PropTypes.func,
  fullWidth: PropTypes.bool,
  multiLine: PropTypes.bool,
  handleBlur: PropTypes.func,
  inputProps: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  error: PropTypes.string,
  dataTestId: PropTypes.string,
  dataTestIdForLabel: PropTypes.string,
  placeholder: PropTypes.string,
  endAdornment: PropTypes.object,
  noColon: PropTypes.bool,
  isStar: PropTypes.bool,
  flow: PropTypes.string,
};
